import PropTypes from "prop-types";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { changeLanguage } from "redux-multilanguage";
import { useSelector } from "react-redux";
import { LANGUAGE_LABELS, getAvailableLanguages, getDefaultLanguage, changeLanguageUrl } from "../../../../utils/languages";
import { CURRENCIES } from "../../../../utils/constants/currencies";

const LanguageCurrencyChanger = ({ currency, changeCurrency, currentLanguageCode, dispatch }) => {
    const history = useHistory();
    const location = useLocation();
    const siteData = useSelector((state) => state.siteData);
    const availableLanguages = getAvailableLanguages(siteData);
    const defaultLanguage = getDefaultLanguage(siteData);

    const changeLanguageTrigger = (e) => {
        const languageCode = e.target.value;
        dispatch(changeLanguage(languageCode));
        changeLanguageUrl(location, history, languageCode, defaultLanguage, availableLanguages);
    };

    return (
        <div className="language-currency-wrap">
            <div className="same-language-currency language-style">
                <span>
                    {LANGUAGE_LABELS[currentLanguageCode] || currentLanguageCode} <i className="fa fa-angle-down" />
                </span>
                <div className="lang-car-dropdown">
                    <ul>
                        {availableLanguages.map((lang) => (
                            <li key={lang}>
                                <button value={lang} onClick={(e) => changeLanguageTrigger(e)}>
                                    {LANGUAGE_LABELS[lang] || lang}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="same-language-currency use-style">
                <span>
                    {currency.currencyName} <i className="fa fa-angle-down" />
                </span>
                <div className="lang-car-dropdown">
                    <ul>
                        {Object.keys(CURRENCIES).map((currency) => (
                            <li key={currency}>
                                <button value={currency} onClick={() => changeCurrency(currency)}>
                                    {currency}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="same-language-currency">
                <p>Call Us 3965410</p>
            </div>
        </div>
    );
};

LanguageCurrencyChanger.propTypes = {
    changeCurrency: PropTypes.func,
    currency: PropTypes.object,
    currentLanguageCode: PropTypes.string,
    dispatch: PropTypes.func,
};

export default LanguageCurrencyChanger;
